<template>
  <div>
    <div class="row">
      <div v-if="groups.length === 0 && !loading" class="alert alert-warning">
        No groups found. Please check your configuration or add groups.
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="publicationName" placeholder="Publication Name"
            v-model="publicationName" />
          <label for="publicationName" style="margin-left:10px">Publication Name</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <input type="text" class="form-control" id="publicationInstitution" placeholder="Institution"
            v-model="Pub_institution" />
          <label for="publicationInstitution" style="margin-left:10px">Institution</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <input type="email" class="form-control" id="supervisorEmail" placeholder="Supervisor Email"
            v-model="supervisorEmail" />
          <label for="supervisorEmail" style="margin-left:10px">Supervisor Email</label>
        </div>
      </div>
      <div class="col">
        <!-- Test Type Filter -->
        <div class="form-floating mb-2">
          <select class="form-select" v-model="testTypeFilter" id="TestTypeFilter" @change="onTestTypeFilterChange">
            <option value="all">All Tests</option>
            <option value="linear">Linear Tests Only</option>
            <option value="adaptive">CAT Tests Only</option>
            <option value="conditional">Conditional Tests Only</option>
          </select>
          <label for="TestTypeFilter">Test Type</label>
        </div>

        <!-- Test Selection -->
        <div class="form-floating mb-2">
          <select class="form-select" v-model="selectedTest" id="TestSelect" @change="onTestSelectionChange">
            <option value="" disabled>Select a test in the list</option>
            <option v-for="test in filteredTests" :key="test._id" :value="test._id">
              {{ test.title }}
              <span v-if="test.progression === 'adaptive'"> 🐈</span>
              <span v-if="test.progression === 'conditional'"> 🔀</span>
            </option>
          </select>
          <label for="TestSelect">Select a test ({{ filteredTests.length }} available)</label>
        </div>
        <!-- Message CAT Alert -->
        <div v-if="isCATTest" class="alert alert-info mt-2" role="alert">
          <i class="fas fa-info-circle me-2"></i>
          <strong>This test is a CAT test!</strong> Some form fields will be automatically configured for adaptive testing.
        </div>
        <!-- Progression Type Display -->
        <div v-if="selectedTest" class="mt-2">
          <small class="text-muted">
            <i class="fas fa-route me-1"></i>
            Test progression: <strong class="text-primary">{{ progressionType }}</strong>
          </small>
        </div>
      </div>
    </div>

    <div class="row">
      
      <div class="col">
        <div class="form-floating">
          <select class="form-select" v-model="selectedGroup" id="GroupSelect" @change="onGroupSelectionChange">
            <option value="" disabled>Open this select menu</option>
            <option v-for="group in groups" :key="group._id" :value="group._id">
              {{ group.groupName }}
            </option>
          </select>
          <label for="GroupSelect">Select a Group</label>
        </div>
        <!-- Alert pour groupe de simulation -->
        <div v-if="isSimulationGroup" class="alert alert-info mt-2" role="alert">
          <i class="fas fa-robot me-2"></i>
          <strong>🤖 Groupe de simulation détecté !</strong> La publication sera automatiquement configurée pour les simulations IA.
        </div>
      </div>
      <div class="col">
        <div class="form-floating">
          <textarea class="form-control" placeholder="Add some important details" id="PubDescription"
            v-model="description"></textarea>
          <label style="margin-left:10px" for="PubDescription">Description</label>
        </div>
      </div>

    </div>


    
    <div class="row mt-3">
      <div class="col">
        <div class="form-floating mb-3">
          <input type="date" class="form-control" id="startingDate" v-model="startingDate" />
          <label for="startingDate" class="form-label">Starting Date</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating mb-3">
          <input type="date" class="form-control" id="endDate" v-model="endDate" />
          <label for="endDate" class="form-label">End Date</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating">
          <select class="form-select" id="access" v-model="access">
            <option value="unique">Unique</option>
            <option value="multiple">Multiple</option>
          </select>
          <label for="access" class="form-label">Access</label>
        </div>
      </div>
     <!--  <div class="col">
        <div class="form-floating">
          <input
          type="number"
          :min="access === 'multiple' ? 2 : 1"
          class="form-control"
          id="AttemptLimit"
          v-model="attemptLimit"
          :disabled="access !== 'multiple'"
        >
        <label for="AttemptLimit">Attempts limit (only for multiple access)</label>
        </div>
      </div> -->
    </div>

    <div class="row mb-4">
      <div class="col">
        <div class="form-floating">
          <select id="mode" class="form-select" v-model="mode" title="Test Mode">
            <option value="exam">Exam</option>
            <option value="learning">Formative mode</option>
            <option disabled value="live">Live</option>
            <option disabled value="custom">Custom</option>
          </select>
          <label for="mode">Test Mode {{ isCATTest ? '(CAT Compatible)' : '' }}</label>
        </div>
      </div>
      <div class="col">
        <div class="form-floating">
          <select id="Tnav" class="form-select" v-model="browsing" title="Browsing" :disabled="isCATTest || isConditional">
            <option value="backPossible">Browsing back is possible</option>
            <option value="noBack">Browsing back is not allowed</option>
          </select>
          <label for="Tnav">Browsing {{ (isCATTest || isConditional) ? '(Disabled for CAT and Conditional)' : '' }}</label>
        </div>
      </div>
     <!--  <div class="col">
        <div class="form-floating">
          <select id="TSub" class="form-select" v-model="submission" title="Submission Mode">
            <option value="eachQuestion">Each question</option>
            <option value="eachPage">Each page</option>
            <option value="endTest">End of test</option>
          </select>
          <label for="TSub">Answers submission mode</label>
        </div>
      </div> -->

    </div>
    <div class="row mb-4">
      <div class="col ml-2">
        <div class="form-check form-switch">
          <input disabled class="form-check-input" type="checkbox" id="settingShuffleQuestions"
            v-model="shuffleQuestions">
          <label class="form-check-label" for="settingShuffleQuestions">Shuffle Questions in page</label>
        </div>
        <div class="form-check form-switch">
          <input disabled class="form-check-input" type="checkbox" id="settingShufflePages"
            v-model="shufflePages">
          <label class="form-check-label" for="settingShufflePages">Shuffle pages</label>
        </div>
        
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="settingTimeLimit" 
            v-model="timeLimit">
          <label class="form-check-label" for="settingTimeLimit">Time limit</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="settingSkip"
            v-model="skip" :disabled="isCATTest || isConditional">
          <label class="form-check-label" for="settingSkip">Skip is allowed {{ (isCATTest || isConditional) ? '(Disabled for CAT and Conditional)' : '' }}</label>
        </div>
        
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="testMap"
            v-model="testMap" :disabled="isCATTest || isConditional">
          <label class="form-check-label" for="testMap">Test Map {{ (isCATTest || isConditional) ? '(Disabled for CAT and Conditional)' : '' }}</label>
        </div>
        <div class="form-check form-switch">
          <input disabled class="form-check-input" type="checkbox" id="complementarytools" 
              v-model="ctools">
          <label class="form-check-label" for="complementarytools">Complementary tools</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="ReadOnlyAnsw"
              v-model="readOnlyAnswer" :disabled="isCATTest || isConditional">
          <label class="form-check-label" for="ReadOnlyAnsw">Read-only once answered {{ (isCATTest || isConditional) ? '(Disabled for CAT and Conditional)' : '' }}</label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="revealQuestionNB"
              v-model="revealQuestionNB" :disabled="isCATTest || isConditional">
          <label class="form-check-label" for="revealQuestionNB">Reveal Question number {{ (isCATTest || isConditional) ? '(Disabled for CAT and Conditional)' : '' }}</label>
        </div>
      </div>
      <div class="col">
        <div class="mb-2"><b>Last page elements</b></div>
        <div class="form-floating mb-2">
          <textarea class="form-control" placeholder="Thank you for your participation" id="PubLeaveMessage"
            v-model="leaveMessage"></textarea>
          <label style="margin-left:10px" for="PubLeaveMessage">Leave Message</label>
        </div>
        <div class="notice">
          The open-ended question are excluded of the score calculation in that version.
        </div>
        <div class="form-check form-switch mb-2">
          <input class="form-check-input" type="checkbox" id="settingDirectScore"
            v-model="directScore_FB">
          <label class="form-check-label" for="settingDirectScore">Final score report</label>
        </div>
        <div class="form-check form-switch mb-2">
          <input disabled class="form-check-input" type="checkbox" id="AICorrection" 
            v-model="AICorr">
          <label class="form-check-label" for="AICorrection">AI Correction</label>
        </div>
      </div>
    </div>

    <div hidden class="row mb-4 mt-4">
      <div class="col-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="StudentReport" v-model="studentReport">
          <label class="form-check-label" for="StudentReport">Student Report</label>
        </div>
      </div>
      <div class="col-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="GroupReport" v-model="groupReport">
          <label class="form-check-label" for="GroupReport">Group Report</label>
        </div>
      </div>
      <div class="col-2">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="StatisticReport" v-model="statisticReport">
          <label class="form-check-label" for="StatisticReport">Statistic Report</label>
        </div>
      </div>
    </div>

    <button class="btn btn-primary mb-4" @click="submitForm">Add a new Publication</button>
  </div>
</template>

<script setup>
import { useEventBus } from '@vueuse/core'
import { ref, computed, onMounted, watch } from 'vue'
import api from "@/services/axios";

// Créez un bus d'événements
const eventBus = useEventBus('publication-updated')


// Refs
const loading = ref(true)
const tests = ref([])
const groups = ref([])
const selectedTest = ref('')
const selectedGroup = ref('')
const testTypeFilter = ref('all')
const publicationName = ref('')
const Pub_institution = ref('')
const startingDate = ref('')
const endDate = ref('')
const attemptLimit = ref(1)
const access = ref('unique')
const description = ref('')
const leaveMessage = ref('')
const mode = ref('')
const submission = ref('')
const browsing = ref('')
const shuffleQuestions = ref(false)
const shufflePages = ref(false)
const directScore_FB= ref(false)
const timeLimit = ref(false)
const skip = ref(false)
const AICorr = ref(false)
const testMap = ref(true)
const ctools = ref(false)
const readOnlyAnswer = ref(false)
const revealQuestionNB = ref(false)
const studentReport = ref(false)
const groupReport = ref(false)
const statisticReport = ref(true)
const supervisorEmail = ref('')

// CAT Test detection
const isCATTest = ref(false)
const isConditional = ref(false)
const selectedTestData = ref(null)
const progressionType = ref('linear')

// Simulation group detection
const isSimulationGroup = ref(false)
const selectedGroupData = ref(null)


const fetchData = async () => {
  try {
    const [testRes, groupRes] = await Promise.all([
      api.get(`/tests/getTests`, { params: { size: 1000 } }), // Augmenter la limite pour tout charger
      api.get(`/groups`)
    ])

    tests.value = testRes.data.tests
    groups.value = groupRes.data.groups

    // Debug: Afficher les tests CAT détectés
    console.log('📊 Total tests loaded:', tests.value.length)
    const catTests = tests.value.filter(test => test.progression === 'adaptive')
    console.log('🐈 CAT tests found:', catTests.length)
    if (catTests.length > 0) {
      console.log('🐈 CAT tests:', catTests.map(t => ({ title: t.title, progression: t.progression })))
    }
  } catch (error) {
    console.error('Failed to fetch tests or groups', error)
  } finally {
    loading.value = false
  }
}

// Modifiez la fonction submitForm
const submitForm = async () => {
  const publicationData = {
  publicationName: publicationName.value,
  institution: Pub_institution.value,
  testId: selectedTest.value,
  groupId: selectedGroup.value,
  startingDate: startingDate.value,
  endDate: endDate.value,
  access: access.value,
  attemptLimit: attemptLimit.value,
  description: description.value,
  leaveMessage: leaveMessage.value,
  mode: mode.value,
  submission: submission.value,
  browsing: browsing.value,
  progressionType: progressionType.value, // Nouveau champ ajouté
  shuffleQuestions: shuffleQuestions.value,
  shufflePages: shufflePages.value,
  directScore_FB: directScore_FB.value,
  timeLimit: timeLimit.value,
  skip: skip.value,
  AICorr: AICorr.value,
  testMap: testMap.value,
  ctools: ctools.value,
  readOnlyAnswer: readOnlyAnswer.value,
  revealQuestionNB: revealQuestionNB.value,
  supervisorEmail: supervisorEmail.value,
  attempts: 0,
  reports: {
    studentReport: studentReport.value,
    groupReport: groupReport.value,
    statisticReport: statisticReport.value,
  },
  simulation: isSimulationGroup.value, // Propager la propriété simulation du groupe vers la publication
};

  try {
    console.log("publicationData envoyé :", publicationData);
    const response = await api.post(`/publications`, publicationData)
    alert('Publication added successfully')

    // Émettez l'événement après création réussie
    eventBus.emit('refresh-publications')

    // Réinitialisez le formulaire si besoin
    publicationName.value = ''
    Pub_institution.value = ''
    supervisorEmail.value = ''
    selectedTest.value = ''
    selectedGroup.value = ''
    // ... autres réinitialisations
  } catch (error) {
    console.error('Failed to add publication', error.response?.data || error.message)
  }
}

// Valeurs par défaut pour les tests linéaires
const defaultLinearSettings = {
  mode: 'exam',
  browsing: 'backPossible',
  skip: true,
  testMap: true,
  readOnlyAnswer: false,
  revealQuestionNB: true
}

// Fonction pour détecter et configurer le groupe de simulation
const onGroupSelectionChange = async () => {
  if (!selectedGroup.value) {
    isSimulationGroup.value = false
    selectedGroupData.value = null
    return
  }

  try {
    // Chercher le groupe dans la liste déjà chargée
    const groupData = groups.value.find(group => group._id === selectedGroup.value)
    
    if (!groupData) {
      console.warn('Groupe non trouvé dans la liste chargée')
      isSimulationGroup.value = false
      selectedGroupData.value = null
      return
    }
    
    selectedGroupData.value = groupData
    
    // Debug : Afficher les propriétés du groupe
    console.log('🔍 DEBUG - Groupe sélectionné:', groupData.groupName)
    console.log('🔍 DEBUG - Simulation:', groupData.simulation)
    
    // Détecter si c'est un groupe de simulation
    isSimulationGroup.value = !!groupData.simulation
    
    if (isSimulationGroup.value) {
      console.log('🤖 Groupe de simulation détecté ! La publication héritera de simulation=true')
    } else {
      console.log('👥 Groupe normal détecté')
    }
    
  } catch (error) {
    console.error('Error processing group selection:', error)
    isSimulationGroup.value = false
    selectedGroupData.value = null
  }
}

// Fonction pour détecter et configurer le test CAT ou Conditional
const onTestSelectionChange = async () => {
  if (!selectedTest.value) {
    isCATTest.value = false
    isConditional.value = false
    selectedTestData.value = null
    resetToDefaultSettings()
    return
  }

  try {
    // Chercher le test dans la liste déjà chargée
    const testData = tests.value.find(test => test._id === selectedTest.value)

    if (!testData) {
      console.warn('Test non trouvé dans la liste chargée')
      isCATTest.value = false
      isConditional.value = false
      selectedTestData.value = null
      resetToDefaultSettings()
      return
    }
    
    selectedTestData.value = testData
    
    // Debug : Afficher toutes les propriétés du test pour diagnostic
    console.log('🔍 DEBUG - Test sélectionné:', testData.title)
    console.log('🔍 DEBUG - Progression:', testData.progression)
    console.log('🔍 DEBUG - CATParameters présent:', !!testData.CATParameters)
    console.log('🔍 DEBUG - CATStructure présent:', !!testData.CATStructure)
    console.log('🔍 DEBUG - CATDistribution présent:', !!testData.CATDistribution)
    
    if (testData.CATParameters) {
      console.log('🔍 DEBUG - CATParameters contenu:', testData.CATParameters)
    }
    if (testData.CATStructure) {
      console.log('🔍 DEBUG - CATStructure contenu:', testData.CATStructure)
    }
    if (testData.CATDistribution) {
      console.log('🔍 DEBUG - CATDistribution contenu:', testData.CATDistribution)
    }
    
    // Définir le type de progression basé sur les données du test
    progressionType.value = testData.progression || 'linear'

    // Vérifier si c'est un test CAT (adaptatif) ou Conditional
    const isAdaptive = testData.progression === 'adaptive'
    const isConditionalTest = testData.progression === 'conditional'

    isCATTest.value = isAdaptive
    isConditional.value = isConditionalTest

    if (isAdaptive) {
      console.log('🐈 CAT Test detected! Configuring publication settings...')
      console.log('📊 Progression type set to:', progressionType.value)

      // Configuration automatique pour CAT
      applyCATSettings()
      console.log('✅ CAT settings applied')
    } else if (isConditionalTest) {
      console.log('🔀 Conditional Test detected! Configuring publication settings...')
      console.log('📊 Progression type set to:', progressionType.value)

      // Configuration automatique pour Conditional (même que CAT)
      applyConditionalSettings()
      console.log('✅ Conditional settings applied')
    } else {
      console.log('📝 Non-adaptive test detected - applying default settings')
      console.log('📊 Progression type set to:', progressionType.value)
      applyLinearSettings()
      console.log('✅ Default settings applied')
    }
    
  } catch (error) {
    console.error('Error processing test selection:', error)
    isCATTest.value = false
    isConditional.value = false
    selectedTestData.value = null
    resetToDefaultSettings()
  }
}

// Fonction pour appliquer les paramètres CAT
const applyCATSettings = () => {
  // Mode libre pour CAT : exam ou learning supportés
  // mode.value reste inchangé pour permettre la sélection
  browsing.value = 'noBack'
  skip.value = false
  testMap.value = false
  readOnlyAnswer.value = false
  revealQuestionNB.value = false
}

// Fonction pour appliquer les paramètres Conditional (même comportement que CAT)
const applyConditionalSettings = () => {
  // Mode libre pour Conditional : exam ou learning supportés
  // mode.value reste inchangé pour permettre la sélection
  browsing.value = 'noBack'
  skip.value = false
  testMap.value = false
  readOnlyAnswer.value = false
  revealQuestionNB.value = false
}

// Fonction pour appliquer les paramètres par défaut pour les tests linéaires
const applyLinearSettings = () => {
  mode.value = defaultLinearSettings.mode
  browsing.value = defaultLinearSettings.browsing
  skip.value = defaultLinearSettings.skip
  testMap.value = defaultLinearSettings.testMap
  readOnlyAnswer.value = defaultLinearSettings.readOnlyAnswer
  revealQuestionNB.value = defaultLinearSettings.revealQuestionNB
}

// Fonction pour remettre les paramètres par défaut (aucun test sélectionné)
const resetToDefaultSettings = () => {
  mode.value = ''
  browsing.value = ''
  skip.value = false
  testMap.value = true
  readOnlyAnswer.value = false
  revealQuestionNB.value = false
  progressionType.value = 'linear'
  isCATTest.value = false
  isConditional.value = false
}

// Computed pour filtrer les tests selon le type sélectionné
const filteredTests = computed(() => {
  console.log('🔍 Filtering tests, filter:', testTypeFilter.value, 'Total tests:', tests.value.length)

  if (testTypeFilter.value === 'all') {
    return tests.value
  } else if (testTypeFilter.value === 'linear') {
    const filtered = tests.value.filter(test => test.progression !== 'adaptive')
    console.log('📋 Linear tests:', filtered.length)
    return filtered
  } else if (testTypeFilter.value === 'adaptive') {
    const filtered = tests.value.filter(test => test.progression === 'adaptive')
    console.log('🐈 CAT tests filtered:', filtered.length)
    if (filtered.length > 0) {
      console.log('🐈 CAT tests details:', filtered.map(t => ({ title: t.title, progression: t.progression })))
    }
    return filtered
  }  else if (testTypeFilter.value === 'conditional') {
    const filtered = tests.value.filter(test => test.progression === 'conditional')
    console.log('Conditional test Filtered:', filtered.length)
    if (filtered.length > 0) {
      console.log('Conditional tests details:', filtered.map(t => ({ title: t.title, progression: t.progression })))
    }
    return filtered
  }
  
  return tests.value
})

// Handler pour le changement de filtre de type
const onTestTypeFilterChange = () => {
  // Réinitialiser la sélection si le test sélectionné n'est plus dans la liste filtrée
  if (selectedTest.value) {
    const testStillAvailable = filteredTests.value.some(test => test._id === selectedTest.value)
    if (!testStillAvailable) {
      selectedTest.value = ''
      isCATTest.value = false
      isConditional.value = false
      selectedTestData.value = null
      resetToDefaultSettings()
    }
  }
}

watch(access, (newVal) => {
  if (newVal === 'unique') {
    attemptLimit.value = 1
  }
})


onMounted(fetchData)
</script>

<style scoped>
.notice{
  font-style: italic;
  color: gray;  
  font-size: small;
}
</style>